import React from 'react';
import PropTypes from 'prop-types';

export const is_express = (day) => day <= 5
export const getClassName = (day) => (is_express(day) ? 'express-th-cell' : 'standard-th-cell')
const getClassHeaderName = (day) => (is_express(day) ? 'express-th-cell' : 'standard-th-cell standard-th-cell-header')

const PriceMatrixHead = (props) => {
  const text = (d) => `${d} ${d === 1 ? 'day' : 'days'}`;

  const expressColSpan = props.leadTimes
    // eslint-disable-next-line no-return-assign, no-param-reassign
    .reduce((accumulator, currentvalue) => (accumulator += is_express(currentvalue) ? 1 : 0), 0)

  const standardSpan = props.leadTimes
    // eslint-disable-next-line no-return-assign, no-param-reassign
    .reduce((accumulator, currentvalue) => (accumulator += !is_express(currentvalue) ? 1 : 0), 0)

  return (

    <thead className="price-matrix-table-head">
      <tr>
        <th className="qty" rowSpan="2">Qty</th>
        {expressColSpan > 0 ? <th className="express-th" colSpan={expressColSpan}>PROTOTYPE PCB ASSEMBLY SERVICE</th> : null}
        {standardSpan > 0 ? <th className="standard-th" colSpan={standardSpan}>PRODUCTION PCB ASSEMBLY SERVICE</th> : null}
      </tr>
      <tr>
        {props.leadTimes.map((qty) => (
          <th className={getClassHeaderName(qty)} key={qty}>
            {text(qty)}
          </th>
        ))}
      </tr>
    </thead>
  );
}

PriceMatrixHead.propTypes = {
  leadTimes: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default PriceMatrixHead;
